import React, { useState } from 'react'
import { Button, Notification } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import { IconS24Lightbulb24, IconS24Upload48 } from '@is24/cosma-ui-icons'
import { useAppSelector } from '../../../../app/hooks'
import { InitState } from '../../../../redux/reducers/root/initialState'
import { isEditEntryMode } from '../../../../@types/types'
import { AiDataExtractionUploadModal } from './AiDataExtractionUploadModal'
import { useToastContext } from '../../../../app/toast/toastContext'
import { trackAiDataExtractionBannerClick } from './aiDataExtractionTracking'
import { hasListingTypeChangeCopyContext } from '../listingTypeChange/listingTypeChangeContext'

export const AiDataExtractionBanner = () => {
  const { t } = useTranslation()
  const toastContext = useToastContext()
  const entryMode = useAppSelector(
    (state: InitState) => state.insertionFeature.insertionIdentification.metaInformation?.entryMode
  )
  const isAiDataExtractionSupported = useAppSelector(
    (state: InitState) => state.flowFeature.flowInformation.options?.hasAiDataExtractionBanner
  )
  const flowInformation = useAppSelector((state: InitState) => state.flowFeature.flowInformation)
  const isEditFlow = isEditEntryMode(entryMode)
  const [dismissedInSession, setDismissedInSession] = useState(false)
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false)
  const [extractionApiError, setExtractionApiError] = useState(false)

  if (dismissedInSession || isEditFlow || !isAiDataExtractionSupported || hasListingTypeChangeCopyContext()) {
    return null
  }

  return (
    <div className='margin-bottom-l' data-testid='ai-data-extraction-banner'>
      <Notification.Root type={'neutral'} variant={'flat'}>
        <Notification.Icon data-testid='ai-data-extraction-banner-bulb'>
          <IconS24Lightbulb24 />
        </Notification.Icon>
        <Notification.Content>
          <Notification.Title>{t('wizard.uploadAiBanner.title')}</Notification.Title>
          <Notification.Message>{t('wizard.uploadAiBanner.message')}</Notification.Message>
          <Notification.Action>
            <Button
              variant={'filledWeak'}
              endElement={<IconS24Upload48 />}
              onClick={() => {
                trackAiDataExtractionBannerClick(flowInformation, entryMode)
                setIsUploadModalOpen(true)
              }}
            >
              {t('wizard.uploadAiBanner.cta')}
            </Button>
          </Notification.Action>
        </Notification.Content>
        <Notification.CloseButton onClick={() => setDismissedInSession(true)} />
      </Notification.Root>
      <AiDataExtractionUploadModal
        extractionApiError={extractionApiError}
        isOpen={isUploadModalOpen}
        onClearExtractionApiError={() => setExtractionApiError(false)}
        onClose={() => {
          setIsUploadModalOpen(false)
          setExtractionApiError(false)
        }}
        onExtractionFailed={() => {
          setIsUploadModalOpen(true)
          setExtractionApiError(true)
        }}
        onSuccess={() => {
          setExtractionApiError(false)
          toastContext?.addToast({
            headline: t('wizard.uploadAiBanner.toast.headline'),
            message: t('wizard.uploadAiBanner.toast.message'),
            type: 'success',
            timeout: 6000,
            variant: 'elevated',
          })
        }}
      />
    </div>
  )
}
